import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCzT1LPD_5REhXf-6DxCJPfBKD9UgvS9K0",
  authDomain: "bbe-intern.firebaseapp.com",
  projectId: "bbe-intern",
  storageBucket: "bbe-intern.firebasestorage.app",
  messagingSenderId: "926928771698",
  appId: "1:926928771698:web:e6ad21bcb946ae0c6200eb",
  measurementId: "G-67C90EFLM5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialisera messaging endast om det stöds
let messagingInstance: any = null;

// Försök att initiera messaging på ett säkert sätt
const initMessaging = async () => {
  try {
    const isFCMSupported = await isSupported();
    
    if (isFCMSupported) {
      messagingInstance = getMessaging(app);
      console.log('Firebase Cloud Messaging initialiserat framgångsrikt');
      return messagingInstance;
    } else {
      console.log('Firebase Cloud Messaging stöds inte i denna miljö');
      return null;
    }
  } catch (error) {
    console.error('Fel vid initialisering av Firebase Cloud Messaging:', error);
    return null;
  }
};

// Exportera en funktion för att få messaging-instansen
export const getMessagingInstance = async () => {
  if (!messagingInstance) {
    return await initMessaging();
  }
  return messagingInstance;
};

// För bakåtkompatibilitet, men använd getMessagingInstance() istället
export const messaging = null;
